import "./Preload.css";
import Settings from "./Settings.js";
import Scene from "./Scene.js";
import { Leva, useControls } from "leva";
import { Canvas } from "@react-three/fiber";
import * as THREE from "three";

const Preload = () => {
  const rendererProps = useControls(
    "Renderer",
    {
      outputColorSpace: {
        value: THREE.SRGBColorSpace,
        options: {
          LinearSRGB: THREE.LinearSRGBColorSpace,
          SRGB: THREE.SRGBColorSpace,
        },
      },
      toneMapping: {
        value: THREE.NeutralToneMapping,
        options: {
          NoToneMapping: THREE.NoToneMapping,
          LinearToneMapping: THREE.LinearToneMapping,
          ReinhardToneMapping: THREE.ReinhardToneMapping,
          CineonToneMapping: THREE.CineonToneMapping,
          ACESFilmicToneMapping: THREE.ACESFilmicToneMapping,
          AgXToneMapping: THREE.AgXToneMapping,
          NeutralToneMapping: THREE.NeutralToneMapping,
        },
      },
      toneMappingExposure: {
        value: 0.7,
        min: 0,
        max: 3,
        step: 0.01,
      },
    },
    { collapsed: true }
  );

  return (
    <>
      <div className="preload">
        <Canvas
          className="preload__canvas"
          gl={{
            ...rendererProps,
          }}
        >
          <Settings />

          <Scene />
        </Canvas>
      </div>

      <Leva hidden={window.location.hash != "#panel"} />

      <button className="reset-button">Reset</button>
    </>
  );
};

export default Preload;
